export const APPLICATION_MOBILE_MENU_OPEN = 'APPLICATION:MOBILE_MENU:OPEN'
export const APPLICATION_MOBILE_MENU_CLOSED = 'APPLICATION:MOBILE_MENU:CLOSED'
export const APPLICATION_PRELUDIUM = 'APPLICATION_PRELUDIUM'
export const APPLICATION_INITIALIZED = 'APPLICATION:INITIALIZED'
export const APPLICATION_READY = 'APPLICATION:READY'
export const APPLICATION_REVEALED = 'APPLICATION:REVEALED'
export const APPLICATION_RESIZE = 'APPLICATION:RESIZE'
export const APPLICATION_SCROLL = 'APPLICATION:SCROLL'
export const APPLICATION_SCROLL_LOCKED = 'APPLICATION:SCROLL_LOCKED'
export const APPLICATION_SCROLL_RELEASED = 'APPLICATION:SCROLL_RELEASED'
export const APPLICATION_FORCED_SCROLL_START = 'APPLICATION:FORCED_SCROLL_START'
export const APPLICATION_FORCED_SCROLL_END = 'APPLICATION:FORCED_SCROLL_END'
export const APPLICATION_OUTLINE = 'APPLICATION:OUTLINE'
export const APPLICATION_VISIBILITY_CHANGE = 'APPLICATION:VISIBILITY_CHANGE'
export const APPLICATION_HIDDEN = 'APPLICATION:HIDDEN'
export const APPLICATION_VISIBLE = 'APPLICATION:VISIBLE'

export const BREAKPOINT_CHANGE = 'BREAKPOINT:CHANGE'

export const IMAGE_LAZYLOADED = 'IMAGE:LAZYLOADED'
export const IMAGE_REVEALED = 'IMAGE:REVEALED'
export const SECTION_LAZYLOADED = 'SECTION:LAZYLOADED'
